/**
 * 复制文本库
 * @author colynchen
 * @example
 * new Clipboard({
 *   text: 'hello, world',
 *   success: function() {},
 *   error: function() {}
 * })
 */
import select from 'select';

export default class Clipboard {
  constructor(options = {}) {
    this.text = options.text;
    this.action = options.action || 'copy';
    this.success = options.success;
    this.error = options.error;
    this.container = options.container || document.body;

    this.initSelection();
  }

  // 创建节点
  initSelection() {
    const isRTL = document.documentElement.getAttribute('dir') === 'rtl';

    this.removeFake();

    this.fakeHandlerCallback = () => this.removeFake();
    this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

    this.fakeElem = document.createElement('textarea');
    // Prevent zooming on iOS
    this.fakeElem.style.fontSize = '12pt';
    // Reset box model
    this.fakeElem.style.border = '0';
    this.fakeElem.style.padding = '0';
    this.fakeElem.style.margin = '0';
    this.fakeElem.style.position = 'absolute';
    this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
    const yPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.fakeElem.style.top = `${yPosition}px`;

    this.fakeElem.setAttribute('readonly', '');
    this.fakeElem.value = this.text;

    this.container.appendChild(this.fakeElem);
    this.selectedText = select(this.fakeElem);

    this.copyText();
  }

  // 移除元素
  removeFake() {
    if (this.fakeHandler) {
      this.container.removeEventListener('click', this.fakeHandlerCallback);
      this.fakeHandler = null;
      this.fakeHandlerCallback = null;
    }

    if (this.fakeElem) {
      this.container.removeChild(this.fakeElem);
      this.fakeElem = null;
    }
  }

  // 复制文本
  copyText() {
    let succeeded = false;
    try {
      document.execCommand(this.action);
      succeeded = true;
    } catch (e) {
      succeeded = false;
    }
    const callback = this[succeeded ? 'success' : 'error'];
    if (typeof callback === 'function') {
      callback({
        action: this.action,
        text: this.text,
      });
    }
  }
}
